import React from 'react'
import PropTypes from 'prop-types'
import { createPortal } from 'react-dom'
import usePortalTarget from 'hooks/usePortalTarget'

interface PageTitleSubtitleProps {
  children: any
}

export const PAGE_TITLE_SUBTITLE_ID = 'PAGE_TITLE_SUBTITLE_ID'

export const PageTitleSubtitle: React.FunctionComponent<PageTitleSubtitleProps> = ({
  children,
}) => {
  const target = usePortalTarget(PAGE_TITLE_SUBTITLE_ID, 'span')

  return createPortal(children, target)
}

PageTitleSubtitle.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.element,
    PropTypes.string,
    PropTypes.node,
  ]),
}
